module.exports = __webpack_public_path__ + "img/cabins-map-mobile--es.d7f759ed.png";